import React from 'react';

import { mdiCheckCircleOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { Box, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

import Modal from '../Modal';

const Container = styled(Box)`
    display: flex;
    align-items: flex-start;
    padding: 0.75rem;

    svg {
        max-width: 40px;
        color: ${(props) => props.theme.palette.success.main};
        margin-right: 1rem;
    }
`;

export const MeetingClaimedModal = () => {
    const { t } = useTranslation('lti');

    return (
        <Modal isOpen onClose={() => {}}>
            <Container>
                <Icon path={mdiCheckCircleOutline} />
                <div>
                    {t('class-claimed-success')} {t('class-claimed-refresh')}
                </div>
            </Container>
        </Modal>
    );
};
